import React, { useState } from "react";
import { compareByYearLevelName } from "../../utils/Utils";
import { NepaliDatePicker } from "nepali-calander";

function AttendanceHeader(props) {

  return (
    <React.Fragment>
      {/* {props.yearLevel && props.classroom ? (
            <div className="tt-group-header">
              <div className="row">
                <div className="col text-center">
                  Attendance for {props.yearLevel.name}{" "}
                  {props.classroom[0].name}
                </div>
              </div>
            </div>
          ) : null} */}
      <div className="tt-group-header">
        {/* <div className="row mb-2">
              <div className="col-md-12 text-center">
                Attendance for:
                <i className="ml-1">{props.calendarDate}</i>
              </div>
            </div> */}
        <div className="row justify-content-center">
          <div className="col-md-1"></div>
          <div className="col-md-1 alignContent"> Attendance For:</div>
          <div className="col-md-auto">
            <select
              name="classRoomName"
              id="classRoomName"
              value={props.classRoomName}
              className="form-control"
              onChange={props.handleClassroomSelect}
            >
              {/* value={classroom.id} */}
              <option value="" disabled selected>
                Select Classroom
              </option>
              {props.classrooms ? (
                props.classrooms
                  .sort(compareByYearLevelName)
                  .map((classroom, idx) => (
                    <option
                      key={idx}
                      value={`${classroom.id},${classroom.yearLevelId}`}
                    >
                      {/* What if yearlevel name is inserted as number(like:1,2,..) */}
                      Class {classroom.yearLevelName}
                      {" - "}
                      {classroom.name}
                    </option>
                  ))
              ) : (
                <option value="null">No Classroom available</option>
              )}
            </select>
          </div>
          <div className="col-md-1 alignContent"> All Subjects:
          </div>
          <div className="col-md-auto">
            <input
            disabled={!props.selectedClassroom}
              type="checkbox"
              style={{ position: "relative", top: "3px" }}
              name="selectAllSubjects"
              onChange={props.checkAllSubjects}
              checked={props.selectAllSubjects}
              value="All"
            />
          </div>
          <div className="col-md-1 alignContent"> Subject:</div>
          <div className="col-md-auto">
            <select
              {...(props.selectAllSubjects || props.classRoomName ==="" ? { disabled: 'disabled' } : "")}
              onChange={props.handleSubjectSelect}
              name="subject"
              id="subject"
              className="form-control ttedu-level-dropdown"
              value={props.selectedSubject?.id ?? ""}
              >
              <option
              disabled selected value={""}
              >
                Select Subject
              </option>
              {props.subjects
                ? props.subjects.map((subject, idx) => (
                  <option key={idx} value={subject.id}>
                    {subject.name}
                  </option>
                ))
                : null}
            </select>
          </div>

          <div className="col-md-1 alignContent">Date:</div>
          <div className="col-md-auto">
            <NepaliDatePicker
              disabled={!props.selectedClassroom}
              type="input"
              calendarMode={localStorage.getItem('calendar-mode')}
              showToggle={true}
              showNationalHoliday={false}
              events={[]}
              onDateSelect={(date) => props.handleCalandarDateChange({ target: { name: 'calendarDate', value: date.ad.date } })}
              value={
                props.calendarDate
              }
              maxDate={new Date().toISOString().substring(0, 10)}
              minDate={props.academicYearStart}
            /> 
          </div>

          <div className="col-md-2 text-center pt-1">
            {props.isHoliday && (
              <span style={{ color: "#ff8f8f" }}>Holiday Selected</span>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AttendanceHeader;
